export default __webpack_public_path__ + "static/media/visa@1,5x.bfa671cc.svg";